import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import reducer from './reducers/reducer';
import developmentImage from './assets/images/default.jpg';
//const uploadedFileUrl = (process.env.NODE_ENV === 'production') ? null : 'https://scaleflex.airstore.io/demo/stephen-walker-unsplash.jpg';
const uploadedFileUrl = developmentImage;

const store = createStore(reducer);

store.dispatch ({
	type: 'SET_STATE',
	state: {
		frameProducts: [],
		productsCount: 0,
	    frameCategories: [],
	    displayCategory: 46,
	    frameLoading: true,
	    selectedFrame: [],
		frameImage: uploadedFileUrl,
	    frameTotal: 0,
	    frameSizeH: 0,
	    frameSizeW: 0,
	    frameFullDimension: 100,
	    canvasImage: null,
	    canvasThumbImage: null,
		frameImageHeight: 40,
		frameImageWidth: 60,
		uploadedImageHeight: 40,
		uploadedImageWidth: 60,
	    imageSizeError: false,
	    aspectRatio: 1.5,
	    framedCalc: {},

		actualFrameSizeH: 0,
	    actualFrameSizeW: 0,
		actualFrameFullDimension: 0,
		canvasFrameTotal: 0,

	    wallcolor: '#fff',

	    roomImages: [],
		selectedRoomImage: [],

	    layouts: [],
		selectedLayout: [],

	    wrapping: [],
		selectedWrapping: [],
		wrapEdge: 'mirror-wrap',

		stretching: [],
		selectedStretching: [],
		stretchingTotal: 0,

		hanging: [],
		selectedHanging: [],

		libraryImageUploading: false,

		showMeHow: false,

    	qty: 1,
    	cartQty: 0,
    	customizeQTY: 0,
    	cart1ItemTotal: 0,
    	uploadedFile: uploadedFileUrl,
		selectedTab: 'stretching',

		viewportWidth: 0,
		viewportHeight: 0,
		rightFrameHeight: 0,
	}
})

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>, document.getElementById('root')
);
//registerServiceWorker();